import { render, staticRenderFns } from "./PerformanceSettingRow.vue?vue&type=template&id=9a984ffe&scoped=true&"
import script from "./PerformanceSettingRow.vue?vue&type=script&lang=js&"
export * from "./PerformanceSettingRow.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceSettingRow.vue?vue&type=style&index=0&id=9a984ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a984ffe",
  null
  
)

export default component.exports